import { toast as sonner } from 'sonner';
import { ApiError } from './api-error';

/**
 * Avisos do sistema.
 *
 * Reexporta o `toast` do sonner para nenhuma tela importar a biblioteca direto — trocá-la
 * um dia seria uma alteração aqui, e não em cada arquivo que avisa alguma coisa.
 */
export const toast = sonner;

/**
 * Exibe o erro de uma requisição.
 *
 * A mensagem sai do catálogo do backend, que já vem em português e específica
 * (`docs/api-contract.md`). Escrever a frase na tela seria manter um segundo dicionário
 * envelhecendo à parte do servidor, e é o que produz "Erro ao salvar" no lugar de
 * "Esta área tem 3 subárea(s)".
 *
 * O `requestId` vai na descrição porque é ele que liga a reclamação de quem usa ao log
 * correlacionado — sem exibi-lo, a pessoa relata "deu erro" e não há por onde começar.
 */
export function toastApiError(error: unknown, fallback = 'Não foi possível concluir a operação.') {
  if (!(error instanceof ApiError)) {
    toast.error(fallback);
    return;
  }

  // Erro de validação traz as mensagens por campo; mostrá-las é o que evita a caça ao
  // campo errado num formulário de vinte linhas.
  const fieldErrors = error.fieldErrors;
  const description =
    fieldErrors.length > 0
      ? fieldErrors.join(' · ')
      : error.requestId
        ? `Código de referência: ${error.requestId}`
        : undefined;

  toast.error(error.message, { description });
}
